import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import type { Combatant } from './simulation'
import { TARGET_ZONES } from './targetedCombat'

export function AttackTargetGuide({
 attacker,defender,accent,
}:{attacker:Combatant;defender:Combatant;accent:string}){
 const root=useRef<THREE.Group>(null)
 const zoneId=attacker.attackTargetZone
 const visible=Boolean(zoneId&&(attacker.attackPhase==='startup'||attacker.attackPhase==='active'))
 const zone=zoneId?TARGET_ZONES[zoneId]:null
 useFrame(({clock})=>{
  if(!root.current||!zone)return
  const pulse=.86+Math.sin(clock.elapsedTime*18)*.08
  root.current.position.set(defender.x,defender.y+zone.y,defender.z+.02)
  root.current.scale.setScalar(pulse*(attacker.attackPhase==='active'?1.12:1))
 })
 if(!visible||!zone)return null
 const active=attacker.attackPhase==='active'
 return <group ref={root} position={[defender.x,defender.y+zone.y,defender.z+.02]} name="contact-omega-target">
  <mesh><ringGeometry args={[.11,.145,24]}/><meshBasicMaterial color={accent} transparent opacity={active?.76:.34} depthWrite={false} blending={THREE.AdditiveBlending}/></mesh>
  <mesh rotation={[0,0,Math.PI/4]}><ringGeometry args={[.18,.19,4]}/><meshBasicMaterial color="#fff" transparent opacity={active?.42:.16} depthWrite={false} blending={THREE.AdditiveBlending}/></mesh>
  <pointLight color={accent} intensity={active?.55:.14} distance={1.15} decay={2}/>
 </group>
}
